/* JuvaBun product pages: dead-tap fixes found in Clarity recordings (Oct 2026). Loaded from snippets/jb-head.liquid
   on product pages except the old Messy Bun page (template messy-bun-control, JB35 V1). Vanilla, deferred.
   Why: Clarity (Oct 2026) showed many dead taps on the main gallery photos, on customer review photos and on the
   demo video. Shoppers expect a tap to open the photo big.
   - Gallery photo (.jb-gal__slide img, not after a swipe): full screen viewer with all gallery photos, starting at
     the one tapped.
   - Review photo (.jb-pdp-rev__media img, not video cards): viewer with that review's photos.
   - Viewer: swipe or arrows between photos, tap the photo to zoom 2.5x at that point (1600px photo) (drag to look around), tap again
     to zoom out. Close button, Escape, or swipe down closes. Page scroll is locked while open.
   - Demo / gallery video (video[data-jb-demo], video[data-jb-galvid]) tapped: sound on + controls (fullscreen).
   - Shade finder result photos (.jb-sf__pick) were dead taps: a tap now chooses that shade, like its button.
   - Klaviyo welcome popup: its last button "FIND MY SHADE" redirects to /pages/find-my-shade and took shoppers off
     the product. On a product page with the finder it now just closes the popup; jb-shade-nudge.js then opens the
     finder here with her hair color already answered (it does that on close after an email). Fallback: open it.
   - window.JBLightbox.open(items, start, source, info): used by the set pieces "quick look" (assets/jb-set.js).
     items: { src, alt } photos or { video: mp4 url, poster } videos (muted autoplay, controls, plays inline).
     info: { title, text, cta }: a caption at the bottom with a big button (cta, default "Back to my set") that closes.
   Nothing loads until the first tap. Tracking (Intelligems, selectors only): dialog.jb-lb (viewed),
   [data-jb-lb-src="gallery"|"review"] on the dialog. */
(() => {
  if (window.__jbLightbox) return;
  window.__jbLightbox = true;

  // Largest candidate of a srcset (gallery photos), else the given URL
  const bigUrl = (img) => {
    const ss = img.getAttribute('srcset') || img.dataset.srcset || '';
    let best = '';
    let bw = 0;
    ss.split(',').forEach((part) => {
      const [u, w] = part.trim().split(/\s+/);
      const n = parseInt(w, 10) || 0;
      if (u && n >= bw) { best = u; bw = n; }
    });
    const u = best || img.currentSrc || img.getAttribute('src') || img.dataset.src || '';
    // Shopify CDN: ask for 1600px so a 2.5x zoom stays sharp on phones
    return u.replace(/([?&]width=)(\d+)/, (m, k, w) => (Number(w) < 1600 ? `${k}1600` : m));
  };
  // Loox photos: the "_mid" size is small; the original upload is the same URL without it
  const reviewUrl = (u) => String(u || '').replace(/_mid(\.\w+)(\?|$)/, '$1$2');

  // Tap cues, added at load (tiny); the viewer CSS is added on first open
  const cue = document.createElement('style');
  cue.textContent = '.jb-gal__slide img,.jb-pdp-rev__media:not(.is-video) img,.jb-sf__pick{cursor:zoom-in}.jb-sf__pick{cursor:pointer}';
  document.head.appendChild(cue);

  let dlg = null;
  let list = [];
  let idx = 0;
  let zoomed = false;

  function css() {
    const st = document.createElement('style');
    st.id = 'jb-lb-css';
    st.textContent = `
.jb-lb{position:fixed;inset:0;width:100%;height:100%;max-width:none;max-height:none;margin:0;padding:0;border:0;background:#111;color:#fff;z-index:2147483000;overscroll-behavior:contain}
.jb-lb::backdrop{background:#111}
.jb-lb__stage{position:absolute;inset:0;overflow:hidden;touch-action:none;display:flex;align-items:center;justify-content:center}
.jb-lb__stage.is-zoom{overflow:auto;touch-action:pan-x pan-y;display:block}
.jb-lb__img{max-width:100%;max-height:100%;object-fit:contain;background:#f5f0ea;user-select:none;-webkit-user-drag:none;cursor:zoom-in}
.jb-lb__stage.is-zoom .jb-lb__img{max-width:none;max-height:none;height:auto;cursor:zoom-out}
.jb-lb__btn{position:absolute;z-index:2;width:48px;height:48px;border-radius:50%;border:0;background:rgba(255,255,255,.92);color:#222;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 1px 6px rgba(0,0,0,.3)}
.jb-lb__btn svg{width:22px;height:22px}
.jb-lb__close{top:max(12px,env(safe-area-inset-top));right:12px}
.jb-lb__prev{left:10px;top:50%;transform:translateY(-50%)}
.jb-lb__next{right:10px;top:50%;transform:translateY(-50%)}
.jb-lb__count{position:absolute;z-index:2;left:50%;bottom:max(16px,env(safe-area-inset-bottom));transform:translateX(-50%);background:rgba(0,0,0,.55);padding:6px 12px;border-radius:999px;font-size:15px}
.jb-lb__hint{position:absolute;z-index:2;left:50%;top:max(20px,env(safe-area-inset-top));transform:translateX(-50%);font-size:14px;opacity:.85;white-space:nowrap}
.jb-lb.is-single .jb-lb__prev,.jb-lb.is-single .jb-lb__next,.jb-lb.is-single .jb-lb__count{display:none}
.jb-lb.is-zoomed .jb-lb__prev,.jb-lb.is-zoomed .jb-lb__next,.jb-lb.is-zoomed .jb-lb__hint{display:none}
.jb-lb__img[hidden]{display:none}
video.jb-lb__img{width:100%;height:100%;cursor:default;background:#000}
.jb-lb.is-video .jb-lb__hint{display:none}
.jb-lb__info{position:absolute;z-index:2;left:0;right:0;bottom:0;padding:14px 16px max(16px,env(safe-area-inset-bottom));background:linear-gradient(transparent,rgba(0,0,0,.82) 28%);display:grid;gap:6px;text-align:left}
.jb-lb__info[hidden]{display:none}
.jb-lb__info strong{font-size:19px;line-height:1.25}
.jb-lb__info span{font-size:16px;line-height:1.4;opacity:.95}
.jb-lb__cta{margin-top:6px;text-align:center;min-height:52px;border:0;border-radius:999px;background:#fff;color:#222;font:inherit;font-size:17px;font-weight:700;cursor:pointer}
.jb-lb.has-info .jb-lb__count{bottom:auto;top:max(20px,env(safe-area-inset-top))}
.jb-lb.has-info .jb-lb__hint{display:none}
.jb-lb.has-info .jb-lb__stage{bottom:150px}
.jb-lb.is-card{inset:0;margin:auto;width:min(92vw,460px);height:fit-content;max-height:92vh;border-radius:18px;background:#fff;color:#222;overflow:auto}
.jb-lb.is-card::backdrop{background:rgba(0,0,0,.55)}
.jb-lb.is-card .jb-lb__stage{position:relative;inset:auto;width:100%;aspect-ratio:1/1;background:#f5f0ea}
.jb-lb.is-card .jb-lb__img{width:100%;height:100%;object-fit:contain}
.jb-lb.is-card .jb-lb__info{position:static;background:none;padding:14px 16px 16px;color:#222}
.jb-lb.is-card .jb-lb__cta{background:var(--jb-cta,#c2185b);color:#fff}
.jb-lb.is-card .jb-lb__count{top:auto;bottom:10px;background:rgba(0,0,0,.5);color:#fff;font-size:14px}
.jb-lb.is-card .jb-lb__prev,.jb-lb.is-card .jb-lb__next{top:calc(min(92vw,460px) / 2)}
.jb-lb.is-card .jb-lb__close{top:10px;right:10px}`;
    document.head.appendChild(st);
  }

  const svg = (d) => `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="${d}" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

  function build() {
    css();
    dlg = document.createElement('dialog');
    dlg.className = 'jb-lb';
    dlg.setAttribute('aria-label', 'Photo viewer');
    dlg.innerHTML = `
      <div class="jb-lb__stage" data-lb-stage><img class="jb-lb__img" alt="" data-lb-img></div>
      <p class="jb-lb__hint" data-lb-hint>Tap the photo to zoom</p>
      <button type="button" class="jb-lb__btn jb-lb__close" data-lb-close aria-label="Close">${svg('M6 6l12 12M18 6L6 18')}</button>
      <button type="button" class="jb-lb__btn jb-lb__prev" data-lb-prev aria-label="Previous photo">${svg('M15 5l-7 7 7 7')}</button>
      <button type="button" class="jb-lb__btn jb-lb__next" data-lb-next aria-label="Next photo">${svg('M9 5l7 7-7 7')}</button>
      <span class="jb-lb__count" data-lb-count aria-live="polite"></span>
      <div class="jb-lb__info" data-lb-info hidden><strong data-lb-title></strong><span data-lb-text></span><button type="button" class="jb-lb__cta" data-lb-cta>Back to my set</button></div>`;
    document.body.appendChild(dlg);
    const stage = dlg.querySelector('[data-lb-stage]');
    const cur = () => dlg.querySelector('[data-lb-img]');

    dlg.querySelector('[data-lb-close]').addEventListener('click', close);
    dlg.querySelector('[data-lb-cta]').addEventListener('click', close);
    dlg.querySelector('[data-lb-prev]').addEventListener('click', () => go(idx - 1));
    dlg.querySelector('[data-lb-next]').addEventListener('click', () => go(idx + 1));
    dlg.addEventListener('cancel', (e) => { e.preventDefault(); close(); });
    dlg.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') go(idx - 1);
      if (e.key === 'ArrowRight') go(idx + 1);
    });

    // Swipe (not zoomed): sideways = next/previous, down = close. A tap toggles zoom at the tapped point.
    let s = null;
    stage.addEventListener('pointerdown', (e) => { if (e.isPrimary) s = { x: e.clientX, y: e.clientY, t: e.timeStamp }; });
    stage.addEventListener('pointerup', (e) => {
      if (!s) return;
      const dx = e.clientX - s.x;
      const dy = e.clientY - s.y;
      const tap = Math.abs(dx) < 10 && Math.abs(dy) < 10 && e.timeStamp - s.t < 500;
      const start = s;
      s = null;
      if (tap) { if ((e.target === cur() && cur().tagName === 'IMG') || zoomed) toggleZoom(start.x, start.y); return; }
      if (zoomed) return;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) go(idx + (dx < 0 ? 1 : -1));
      else if (dy > 90 && Math.abs(dy) > Math.abs(dx)) close();
    });
    stage.addEventListener('pointercancel', () => { s = null; });

    function toggleZoom(cx, cy) {
      const img = cur();
      if (!zoomed) {
        const r = img.getBoundingClientRect();
        const fx = Math.min(1, Math.max(0, (cx - r.left) / (r.width || 1)));
        const fy = Math.min(1, Math.max(0, (cy - r.top) / (r.height || 1)));
        zoomed = true;
        img.style.width = `${Math.round((r.width || stage.clientWidth) * 2.5)}px`;
        stage.classList.add('is-zoom');
        dlg.classList.add('is-zoomed');
        requestAnimationFrame(() => {
          stage.scrollLeft = fx * img.offsetWidth - stage.clientWidth / 2;
          stage.scrollTop = fy * img.offsetHeight - stage.clientHeight / 2;
        });
      } else {
        unzoom();
      }
    }
  }

  function unzoom() {
    zoomed = false;
    if (!dlg) return;
    dlg.querySelector('[data-lb-stage]').classList.remove('is-zoom');
    dlg.querySelector('[data-lb-img]').style.width = '';
    dlg.classList.remove('is-zoomed');
  }

  function go(i) {
    if (!list.length) return;
    unzoom();
    idx = ((i % list.length) + list.length) % list.length;
    // A fresh <img> per photo, swapped in once it has loaded: reusing one <img> let the next photo (other shape,
    // e.g. 1:1 after 4:5) draw inside the previous photo's box until it loaded
    const old = dlg.querySelector('[data-lb-img]');
    if (old.tagName === 'VIDEO') { try { old.pause(); } catch (err) { /* ignore */ } }
    const it = list[idx];
    dlg.classList.toggle('is-video', !!it.video);
    if (it.video) {
      const v = document.createElement('video');
      v.className = 'jb-lb__img';
      v.setAttribute('data-lb-img', '');
      v.muted = true;
      v.autoplay = true;
      v.loop = true;
      v.controls = true;
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      if (it.poster) v.poster = it.poster;
      v.src = it.video;
      old.replaceWith(v);
      v.play().catch(() => {});
      dlg.querySelector('[data-lb-count]').textContent = `${idx + 1} / ${list.length}`;
      return;
    }
    const img = document.createElement('img');
    img.className = 'jb-lb__img';
    img.setAttribute('data-lb-img', '');
    img.alt = it.alt || '';
    img.decoding = 'async';
    const want = idx;
    const swap = () => { if (want !== idx || !old.isConnected) return; old.replaceWith(img); };
    img.onload = swap;
    img.onerror = swap;
    img.src = it.src;
    old.hidden = true; // nothing from the last photo while the next one loads
    if (img.complete) swap();
    dlg.querySelector('[data-lb-count]').textContent = `${idx + 1} / ${list.length}`;
    // warm the next photo
    const nx = list[(idx + 1) % list.length];
    if (list.length > 1 && nx.src) { const n = new Image(); n.src = nx.src; }
  }

  let prevOverflow = '';
  function open(items, start, source, info) {
    if (!items.length) return;
    if (!dlg) build();
    list = items;
    dlg.dataset.jbLbSrc = source;
    const box = dlg.querySelector('[data-lb-info]');
    const has = !!(info && info.title);
    box.hidden = !has;
    dlg.classList.toggle('has-info', has);
    dlg.classList.toggle('is-card', !!(info && info.card));
    dlg.setAttribute('aria-label', has ? info.title : 'Photo viewer');
    if (has) {
      dlg.querySelector('[data-lb-title]').textContent = info.title;
      const tx = dlg.querySelector('[data-lb-text]');
      tx.textContent = info.text || '';
      tx.hidden = !info.text;
      dlg.querySelector('[data-lb-cta]').textContent = info.cta || 'Back to my set';
    }
    dlg.classList.toggle('is-single', items.length < 2);
    prevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    go(start || 0);
  }

  function close() {
    unzoom();
    const v = dlg.querySelector('video[data-lb-img]');
    if (v) { try { v.pause(); } catch (err) { /* ignore */ } }
    document.documentElement.style.overflow = prevOverflow;
    if (dlg.open && typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
  }

  window.JBLightbox = { open: (items, start, source, info) => open(items, start, source || 'api', info) };

  // Klaviyo popup "FIND MY SHADE" (capture phase, before Klaviyo's redirect)
  window.addEventListener('click', (e) => {
    const btn = e.target && e.target.closest && e.target.closest('button, a');
    if (!btn || !/^\s*find my shade\s*>?\s*$/i.test(btn.textContent || '')) return;
    if (!btn.closest('[class*="klaviyo"], [data-testid*="klaviyo"], .needsclick')) return;
    const host = document.querySelector('jb-pdp[data-finder-src], jb-pdp-gen[data-finder-src]');
    if (!host || typeof host.openFinder !== 'function' || !host.querySelector('[data-finder]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const root = btn.closest('[role="dialog"]') || document;
    const x = root.querySelector('button.klaviyo-close-form, button[aria-label="Close dialog"]');
    if (x) x.click();
    setTimeout(() => { const f = host.querySelector('[data-finder]'); if (f && !f.open) host.openFinder(); }, 900);
  }, true);

  document.addEventListener('click', (e) => {
    const t = e.target;
    if (!t || !t.closest) return;

    // Shade finder result photo: choose that shade (same as its button)
    const pick = t.closest('.jb-sf__pick');
    if (pick) {
      const dialog = pick.closest('[data-finder], dialog');
      const f = dialog && dialog._finder;
      const res = f && f.result;
      const host = document.querySelector('jb-pdp[data-finder-src], jb-pdp-gen[data-finder-src]');
      if (!res || !host || typeof host.applyFinderResult !== 'function') return;
      const isBest = pick.classList.contains('jb-sf__pick--best');
      const wrap = pick.closest('.jb-sf__result') || dialog;
      const uses = Array.from(wrap.querySelectorAll('.jb-sf__actions [data-sf-act="use"]'));
      if (uses.length) { const b = uses[isBest ? 0 : 1]; if (b) b.click(); return; } // other products: "Use X" buttons
      const id = isBest ? res.best && res.best.id : res.other && res.other.id;
      if (id) host.applyFinderResult(id, null, false);
      return;
    }

    // Main gallery photo (ignore the click that ends a swipe)
    const gimg = t.closest('.jb-gal__slide img');
    if (gimg) {
      const host = gimg.closest('.jb-pdp--v3, [data-gallery]');
      const pdp = gimg.closest('.jb-pdp--v3');
      if (pdp && (pdp.galJustDragged || pdp.galDragging)) return;
      const track = gimg.closest('[data-gal-track]') || host;
      if (track && track.classList.contains('is-dragging')) return;
      const imgs = Array.from((track || document).querySelectorAll('.jb-gal__slide img'));
      const items = imgs.map((im) => ({ src: bigUrl(im), alt: im.alt })).filter((x) => x.src);
      const start = Math.max(0, imgs.indexOf(gimg));
      open(items, Math.min(start, items.length - 1), 'gallery');
      return;
    }

    // Customer review photo (video cards play their own video)
    const rimg = t.closest('.jb-pdp-rev__media img');
    if (rimg) {
      const media = rimg.closest('.jb-pdp-rev__media');
      if (!media || media.classList.contains('is-video') || t.closest('button')) return;
      let urls = Array.isArray(media._jbImgs) ? media._jbImgs.slice() : [];
      if (!urls.length) { try { urls = JSON.parse(media.dataset.imgs || '[]'); } catch (err) { urls = []; } }
      if (!urls.length) urls = [rimg.dataset.orig || rimg.currentSrc || rimg.getAttribute('src')];
      const items = urls.filter(Boolean).map((u) => ({ src: reviewUrl(u), alt: rimg.alt }));
      open(items, Math.min(media._jbIdx || 0, items.length - 1), 'review');
      return;
    }

    // Demo / gallery video: a tap turns the sound on and shows the controls
    const v = t.closest('video[data-jb-demo], video[data-jb-galvid]');
    if (v && !v.controls) {
      v._jbUser = true;
      v.controls = true;
      v.muted = false;
      v.play().catch(() => { v.muted = true; v.play().catch(() => {}); });
    }
  });
})();
